import store, { RootState } from "../../store";
import { AppContextType } from "../../App";
import { createUserAlertFromSnapshot } from "../../util/alerts";
import { setAlertModalData } from "../../reducer/alerts.reducer";
import { selectChartDrawings } from "../../selectors/chart";
import { toggleAppFullScreen } from '../KeyboardShortcuts/toggleAppFullScreen';
import { getViewFromPathname } from '../../hooks/useSelectView';
import { updateChartConfig } from "../../reducer/chart.reducer";
interface Setting {
    field: string;
    label: string;
    group: string;
}
interface StatusLineSettings {
    [key: string]: boolean;
}

export function splitActiveWidgetHorizontally(appContext: AppContextType) {
    const state = store.getState() as RootState;
    const layoutId = state.homeStore.activeLayout;
    const layout = state.widgetDashboardStore.layouts[layoutId];
    const activeWidgetId = layout?.activeWidget;
    const currentWidget = layout?.widgets?.[activeWidgetId];
    if (currentWidget && appContext.dashboard?.splitPane) {
        appContext.dashboard.splitPane(currentWidget.slotId, 2, true);
    }
}

export function splitActiveWidgetVertically(appContext: AppContextType) {
    const state = store.getState() as RootState;
    const layoutId = state.homeStore.activeLayout;
    const layout = state.widgetDashboardStore.layouts[layoutId];
    const activeWidgetId = layout?.activeWidget;
    const currentWidget = layout?.widgets?.[activeWidgetId];
    if (currentWidget && appContext.dashboard?.splitPane) {
        appContext.dashboard.splitPane(currentWidget.slotId, 2, false);
    }
}

export function deleteCurrentWidget(appContext: AppContextType) {
    const state = store.getState() as RootState;
    const layoutId = state.homeStore.activeLayout;
    const layout = state.widgetDashboardStore.layouts[layoutId];
    const activeWidgetId = layout?.activeWidget;
    const currentWidget = layout?.widgets?.[activeWidgetId];
    currentWidget && appContext.dashboard?.deletePane(currentWidget.slotId)
}

export function handleCreateAlert(appContext: AppContextType) {
    const state = store.getState() as RootState;
    const activeChartId = state.chartStore.activeChartId
    const chartSnapshot = appContext.getChartSnapshot[activeChartId]
    const snapshot = chartSnapshot ? chartSnapshot() : null
    if (!snapshot) return
    store.dispatch(setAlertModalData({ chartSnapshot: snapshot, alert: createUserAlertFromSnapshot(snapshot), edit: false }))
}

export function handleRemoveDrawing(appContext: AppContextType) {
    const state = store.getState() as RootState;
    const activeChartId = state.chartStore.activeChartId
    const drawings = selectChartDrawings(activeChartId)(state)
    drawings?.forEach((drawing: any) => {
        const chart = appContext.getChart(activeChartId)
        const settings = chart?.drawingManager.getSettingsValues(drawing.id)
        if (settings && !settings['indicator']) {
            chart.drawingManager.removeDrawing(drawing.id, true, false)
        }
    })
}

export function onToggleFullscreen(appContext: AppContextType) {
    const view = getViewFromPathname(window.location.pathname)
    toggleAppFullScreen(store.dispatch, appContext, view, 'quick-search')
}

export function onSettingsCheckbox(
    setting: Setting,
    viewKey: string,
    statusLineSettings: StatusLineSettings
) {
    store.dispatch(
        updateChartConfig({
            viewKey,
            config: {
                statusLineSettings: {
                    ...statusLineSettings,
                    [setting.field]: !(statusLineSettings?.[setting.field]??true),
                },
            },
            createIfAbsent: false,
        })
    );
}

export const listOfFunctions: Record<string, (context?: any) => void> = {
    'SplitHorizontalIcon': splitActiveWidgetHorizontally,
    'SplitVerticalIcon': splitActiveWidgetVertically,
    'DeleteWidgetIcon': deleteCurrentWidget,
    'CreateAlertIcon': handleCreateAlert,
    'RemoveDrawingIcon': handleRemoveDrawing,
    'FullscreenIcon': onToggleFullscreen,
};

export const settingsFunction: Record<string, (payload: Setting, viewKey: string, settings: StatusLineSettings) => void> = {
    'settingCheckbox': onSettingsCheckbox,
};



